"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactQuery = require("react-query");
var _core = require("@folio/stripes/core");
var _smartComponents = require("@folio/stripes/smart-components");
var _SettingPage = require("../SettingPage");
var _contexts = require("../contexts");
var _utils = require("../utils");
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useSettings = _ref => {
  let {
    allowGlobalEdit = true,
    dynamicPageExclusions,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    labelOverrides = {},
    persistentPages,
    refdataEndpoint,
    settingEndpoint,
    templateEndpoint
  } = _ref;
  const ky = (0, _core.useOkapiKy)();
  const kintIntl = (0, _hooks.useKintIntl)(passedIntlKey, passedIntlNS);
  const queryParams = (0, _utils.generateKiwtQueryParams)({
    filters: dynamicPageExclusions?.map(dpe => ({
      path: 'section',
      comparator: '!=',
      value: dpe
    })),
    perPage: 100,
    stats: false
  }, {});
  const {
    data: appSettings = [],
    isLoading
  } = (0, _reactQuery.useQuery)(['stripes-kint-components', 'useSettings', 'appSettings', settingEndpoint, queryParams], () => ky(`${settingEndpoint}?${queryParams?.join('&')}`).json());
  const sections = [...new Set(appSettings.map(s => s.section))];
  const dynamic = sections.map(section => {
    return {
      route: section,
      label: kintIntl.formatKintMessage({
        id: `settings.settingsSection.${(0, _utils.toCamelCase)(section)}`,
        fallbackMessage: section
      }),
      component: props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_SettingPage.SettingPagePane, {
        intlKey: passedIntlKey,
        intlNS: passedIntlNS,
        sectionName: section,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SettingPage.SettingPage, {
          allowEdit: allowGlobalEdit,
          intlKey: passedIntlKey,
          intlNS: passedIntlNS,
          labelOverrides: labelOverrides,
          sectionName: section,
          ...props
        })
      })
    };
  });
  const pageList = persistentPages.concat(dynamic).sort(_utils.sortByLabel);
  const intlKey = (0, _hooks.useIntlKey)(passedIntlKey, passedIntlNS);
  const SettingsContextProvider = _ref2 => {
    let {
      children
    } = _ref2;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.SettingsContext.Provider, {
      value: {
        intlKey,
        // This is only here for backwards compatibility... is now grabbed from useIntlKey instead of what's passed in directly
        refdataEndpoint,
        settingEndpoint,
        templateEndpoint
      },
      children: children
    });
  };
  SettingsContextProvider.propTypes = {
    children: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.node])
  };
  const SettingsComponent = props => {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_smartComponents.Settings, {
      pages: pageList,
      paneTitle: kintIntl.formatKintMessage({
        id: 'meta.title'
      }),
      ...props
    });
  };
  const SettingsComponentWithContext = props => {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(SettingsContextProvider, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SettingsComponent, {
        ...props
      })
    });
  };
  return {
    isLoading,
    pageList,
    SettingsComponent: SettingsComponentWithContext,
    SettingsContextProvider
  };
};
var _default = exports.default = useSettings;